import { FORBIDDEN } from 'http-status-codes';
const defaultMessage = 'Something went wrong...';

export default (error, message) => (FORBIDDEN === error.status ? error.data.message : message || defaultMessage);
